/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/phoneNumberFilter.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoPhoneNumberField implements angular.IDirective {
    private filter: angular.IFilterService;
    restrict = "E";
    scope = {
      currentValue: "=ngModel",
      contentKey: "@",
      disabled: "=ngDisabled",
      required: "=ngRequired",
      tabIndex: "=?"
    };

    template = "<div><div class=\"meevo_input_wrapper\"><label translate=\"{{::contentKey}}\" title=\"{{::contentKey}}\"></label><div ng-class=\"{'ng-dirty required_red_bubble ' : required && !currentValue}\"></div></div><input type=\"tel\" autocomplete='off' ng-class=\"{' red_border_invalid' : (!currentValue && required)}\" ng-blur=\"onBlur()\" ng-focus=\"onFocus()\" ng-model=\"maskedValue\" name=\"{{name}}\" aria-label=\"{{::contentKey}}\" title=\"{{::contentKey}}\" ng-disabled=\"disabled\" ng-required=\"required\" tabindex=\"{{tabIndex || 0}}\"/></div>";

    constructor($filter: angular.IFilterService) {
      this.filter = $filter;
    }

    link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
      var filter = this.filter;

      scope.$watch('currentValue', currentVal => {
        var newMaskedVal = filter<any>('meevoPhoneNumber')(currentVal);

        if (scope.maskedValue !== newMaskedVal) {
          scope.maskedValue = newMaskedVal;
        }
      });

      scope.onBlur = () => {
        if (scope.maskedValue.length == 10) {
          scope.currentValue = filter<any>('meevoPhoneNumber')(scope.maskedValue);
          scope.maskedValue = filter<any>('meevoPhoneNumber')(scope.maskedValue);
        } else {
          scope.currentValue = scope.maskedValue;
        }
      }

      scope.onFocus = () => {
        var unmaskedVal = scope.maskedValue.replace(/\D/g, '');
        if (scope.maskedValue != unmaskedVal) {
          scope.maskedValue = unmaskedVal;
        }
      }

      element.on("click", (event: JQueryEventObject) => {
        if (!scope.isDisabled) {
          let target: any = event.target || event.srcElement;
          if (target.id === scope.id) {
            target.select();
          }
          event.preventDefault();
        }
      });

      element.on("keydown", (event: JQueryEventObject) => {
        

        if (_.contains([46, 8, 9, 27, 13, 110, 190], event.keyCode) ||
          // Allow: Ctrl+A
          (event.keyCode === 65 && event.ctrlKey) ||
          // Allow: Ctrl+C
          (event.keyCode === 67 && event.ctrlKey) ||
          // Allow: Ctrl+X
          (event.keyCode === 88 && event.ctrlKey) ||
          // Allow: home, end, left, right
          (event.keyCode >= 35 && event.keyCode <= 39)) {

          if (event.keyCode === 13) {
            scope.onBlur();
            return true;
          }
          // let it happen, don't do anything
          return;
        }

        var target = <HTMLInputElement>event.target;
        var isTextSelected = target.value && target.selectionStart === 0 && target.value.length === target.selectionEnd;

        if (scope.maskedValue && scope.maskedValue.length == 10 && !isTextSelected) { // limit size of phone number, should be a variable; currently only supports US format.
          return false;
        }

        // Ensure that it is a number and stop the keypress
        if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
          event.preventDefault();
        }

        return true;
      });
    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($filter) => {
        return new MeevoPhoneNumberField($filter);
      };

      directive.$inject = ["$filter"];

      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoPhoneNumberField", MeevoPhoneNumberField.factory());
}
